import React, { useState } from 'react';
import { translations } from '../translations';

function ContactForm({ language = 'en' }) {
  const t = translations[language];
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    company: '',
    message: ''
  });
  const [status, setStatus] = useState('idle'); // idle, loading, success, error
  const [statusMessage, setStatusMessage] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('loading');
    setStatusMessage('');

    try {
      // Send email using Brevo
      const response = await fetch('https://api.brevo.com/v3/smtp/email', {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'api-key': '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'
        },
        body: JSON.stringify({
          sender: {
            name: 'Drivi Support',
            email: 'drivitrack@gmail.com'
          },
          to: [{
            email: 'drivitrack@gmail.com',
            name: 'Drivi Support'
          }],
          replyTo: {
            email: formData.email,
            name: `${formData.firstName} ${formData.lastName}`
          },
          subject: `New Contact Form Submission from ${formData.company}`,
          htmlContent: `
            <h2>New Contact Form Submission</h2>
            <p><strong>Name:</strong> ${formData.firstName} ${formData.lastName}</p>
            <p><strong>Email:</strong> ${formData.email}</p>
            <p><strong>Company:</strong> ${formData.company}</p>
            <p><strong>Message:</strong></p>
            <p>${formData.message}</p>
          `
        })
      });

      if (!response.ok) {
        throw new Error('Failed to send message');
      }

      setStatus('success');
      setStatusMessage(t.support.form.successMessage);
      setFormData({
        firstName: '',
        lastName: '',
        email: '',
        company: '',
        message: ''
      });
    } catch (error) {
      setStatus('error');
      setStatusMessage(t.support.form.errorMessage);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-6">
      <div className="grid grid-cols-2 gap-6">
        <div className="col-span-2 sm:col-span-1">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            {t.support.form.firstName}
          </label>
          <input
            type="text"
            name="firstName"
            value={formData.firstName}
            onChange={handleChange}
            required
            className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:ring-2 focus:ring-[#3498DB] focus:border-transparent transition-shadow"
            placeholder={t.support.form.firstNamePlaceholder}
          />
        </div>
        <div className="col-span-2 sm:col-span-1">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            {t.support.form.lastName}
          </label>
          <input
            type="text"
            name="lastName"
            value={formData.lastName}
            onChange={handleChange}
            required
            className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:ring-2 focus:ring-[#3498DB] focus:border-transparent transition-shadow"
            placeholder={t.support.form.lastNamePlaceholder}
          />
        </div>
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          {t.support.form.email}
        </label>
        <input
          type="email"
          name="email"
          value={formData.email}
          onChange={handleChange}
          required
          className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:ring-2 focus:ring-[#3498DB] focus:border-transparent transition-shadow"
          placeholder={t.support.form.emailPlaceholder}
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          {t.support.form.company}
        </label>
        <input
          type="text"
          name="company"
          value={formData.company}
          onChange={handleChange}
          required
          className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:ring-2 focus:ring-[#3498DB] focus:border-transparent transition-shadow"
          placeholder={t.support.form.companyPlaceholder}
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          {t.support.form.message}
        </label>
        <textarea
          name="message"
          value={formData.message}
          onChange={handleChange}
          required
          rows="4"
          className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:ring-2 focus:ring-[#3498DB] focus:border-transparent transition-shadow resize-none"
          placeholder={t.support.form.messagePlaceholder}
        ></textarea>
      </div>

      <button
        type="submit"
        disabled={status === 'loading'}
        className={`w-full bg-[#3498DB] text-white px-6 py-3 rounded-lg font-semibold transition-all duration-300 transform hover:scale-[1.02] hover:shadow-lg ${
          status === 'loading' ? 'opacity-75 cursor-not-allowed' : 'hover:bg-[#2980B9]'
        }`}
      >
        {status === 'loading' ? (
          <div className="flex items-center justify-center">
            <div className="w-5 h-5 border-2 border-white/30 border-t-white rounded-full animate-spin mr-2"></div>
            {t.support.form.sending}
          </div>
        ) : (
          t.support.form.submit
        )}
      </button>

      {statusMessage && (
        <div className={`p-4 rounded-lg text-sm ${
          status === 'success' 
            ? 'bg-green-50 text-green-700 border border-green-100' 
            : 'bg-red-50 text-red-700 border border-red-100'
        }`}>
          {statusMessage}
        </div>
      )}
    </form>
  );
}

export default ContactForm; 